import { hpcAdd, hpcDiv, hpcMul, hpcSubtr } from "./HpcCalculate";

export function qtyStrToQty(qtyStr, qpcStr) {
  let qpcs = (qpcStr + "").split('*');
  let qpc = 1;
  qpcs.forEach(e => {
    qpc = qpc * e;
  });
  let qtys = (qtyStr + "").split('+');

  let qty = 0;
  if (qtys.length > 1) {
    qty = parseFloat(qtys[0] * qpc) + parseFloat(qtys[1]);
  } else {
    qty = parseFloat(qtys[0] * qpc);
  }
  return parseFloat(qty.toFixed(4));
}
//规格转换为数字
export function qpcStrToNumber(qpcStr) {
  let qpcs = (qpcStr + "").split('*');
  let qpc = 1;
  qpcs.forEach(e => {
    qpc = qpc * e;
  });
  return qpc
}

//件数转换为数字
export function qtyStrToNumber(qtyStr, qpcStr) {
  if (!qtyStr) return
  let total = qpcStrToNumber(qpcStr);
  let qtyStrs = (qtyStr + "").split('+');
  let result = parseFloat(qtyStrs[0]);
  if (qtyStrs.length === 2) {
    result = result + hpcDiv(qtyStrs[1], total);
  }
  return result
}

// 件数相加
export function add(qtyStr, addedQtyStr) {
  let qtyStrs = (qtyStr + "").split('+');
  let addQtyStrs = (addedQtyStr + "").split('+');
  let case1 = accAdd(parseFloat(qtyStrs[0]), parseFloat(addQtyStrs[0]));
  let split = qtyStrs.length > 1 ? parseFloat(qtyStrs[1]) : 0;
  let addedSplit = addQtyStrs.length > 1 ? parseFloat(addQtyStrs[1]) : 0;
  let splitResult = accAdd(split, addedSplit);
  if (splitResult === 0)
    return case1 + '';
  return case1 + "+" + splitResult;
}

export function toQtyStr(qty, qpcStr, digits) {
  if (qty === 0) {
    return "0";
  }
  if (qty === undefined || qpcStr === undefined) {
    return "0";
  }
  let qpcs = (qpcStr + "").split('*');
  let qpc = 1;
  qpcs.forEach(e => {
    qpc = accMul(qpc, e);
  });

  let wholeCase = accDiv(qty, qpc);
  if (!/^-?\d+$/.test(accDiv(qty, qpc))) {
    wholeCase = parseInt(wholeCase)
  }

  // 判断是否整除
  if (isPositiveIntegerTimes(qty, qpc)) {
    return wholeCase + '';
  } else {
    let split = parseFloat(qty % qpc);
    if (split === 0) {
      return wholeCase + '';
    } else {
      split = (/^-?\d+$/.test(split)) ? split : split.toFixed(digits ? digits : 4);
      return wholeCase + "+" + split;
    }
  }
}

export function toQtyStrFresh(qty, qpcStr) {
  if (qty === 0) {
    return 0;
  }
  if (qty === undefined || qpcStr === undefined) {
    return 0;
  }
  let qpcs = (qpcStr + "").split('*');
  let qpc = 1;
  qpcs.forEach(e => {
    qpc = accMul(qpc, e);
  });

  let value = accDiv(qty, qpc)
  let qtystr = Number(value.toFixed(4));

  return qtystr;

}

export function compare(qtyStr, qtyStr2) {
  let qtyStrs = (qtyStr + "").split('+');
  let qtyStr2s = (qtyStr2 + "").split('+');

  let case1 = parseInt(qtyStrs[0]);
  let case2 = parseInt(qtyStr2s[0]);

  if (case1 < case2) {
    return -1;
  }

  if (case1 > case2) {
    return 1;
  }

  let split = 0;
  let split2 = 0;
  if (qtyStrs.length > 1) {
    split = parseFloat(qtyStrs[1]);
  }
  if (qtyStr2s.length > 1) {
    split2 = parseFloat(qtyStr2s[1]);
  }
  if (split < split2) {
    return -1;
  }
  if (split > split2) {
    return 1;
  }
  return 0;
}

export function division(qtyStr, row) {
  let qtyStrs = (qtyStr + "").split('+');
  let case1 = Math.round(parseInt(qtyStrs[0]) / row);

  let split = 0;
  if (qtyStrs.length > 1) {
    split = parseFloat(qtyStrs[1]);
  }
  split = Math.round(split / row);
  if (split === 0) {
    return case1 + "";
  }
  return case1 + "+" + split;
}

// 件数相减
export function subtract(qtyStr, subQtyStr) {
  let qtyStrs = (qtyStr + "").split('+');
  let subQtyStrs = (subQtyStr + "").split('+');
  let case1 = parseFloat(qtyStrs[0]) - parseFloat(subQtyStrs[0]);
  if (qtyStrs.length <= 1) {
    return case1 + '';
  }
  let split = parseFloat(qtyStrs[1]);
  let subSplit = subQtyStrs.length > 1 ? parseFloat(subQtyStrs[1]) : 0;
  return case1 + "+" + (split - subSplit);
}

export function fomatFloat(src, pos) {
  return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
}

/**
 * 判断是否整除
 * @param {数量} qty 
 * @param {规格} qpc 
 */
export function isPositiveIntegerTimes(qty, qpc) {
  var t1 = 0, t2 = 0, r1, r2;
  try { t1 = qty.toString().split(".")[1].length } catch (e) { }
  try { t2 = qpc.toString().split(".")[1].length } catch (e) { }
  r1 = Number(qty.toString().replace(".", ""));
  r2 = Number(qpc.toString().replace(".", ""));
  var times = (r1 / r2) * Math.pow(10, t2 - t1);

  if (!(/(^[1-9]\d*$)/.test(times.toString()))) {
    return false;
  }
  else {
    return true;
  }
}

/*********以下函数废弃，请调用HpcCalculate中的函数***********/

/**
 * 两数相除(避免丢失精度)--结果值进行四舍五入
 * @param {*} arg1 
 * @param {*} arg2 
 */
export function accDiv(arg1, arg2) {
  return hpcDiv(arg1, arg2);
}

/**
 * 两数相乘(避免丢失精度)
 * @param {} arg1 
 * @param {*} arg2 
 */
export function accMul(arg1, arg2) {
  return hpcMul(arg1, arg2);
}

/**
 * 两数相加(避免丢失精度)
 * @param {*} arg1 
 * @param {*} arg2 
 */
export function accAdd(arg1, arg2) {
  return hpcAdd(arg1, arg2);
}

/**
 * 两数相减(避免丢失精度) 
 * @param {*} arg1 
 * @param {*} arg2 
 */
export function Subtr(arg1, arg2) {
  return hpcSubtr(arg1, arg2);
}

/**
 * 默认保留4位小数
 * Math.round()的原理是对传入的参数+0.5之后，再向下取整得到的数就是返回的结果，返回值为long型
 */
export function toBePrecision(result, precision = 4) {
  let p = 1;
  for (let i = 0; i < precision; i++) {
    p *= 10;
  }
  return Math.round(result * p) / p;
}

